module.exports = __webpack_public_path__ + "img/isabel-wilkerson.503ab4c8.png";